var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('router-link',{class:`spoke-nav-item${_vm.active ? ' active' : ''}`,attrs:{"to":_vm.pathName,"title":_vm.$t(_vm.titleKey)}},[_c(_vm.iconName,{tag:"component",attrs:{"size":"lg","color":"gray-500","variant":"gray-500"}}),_c('span',{staticClass:"spoke-nav-item-label"},[_vm._v(_vm._s(_vm.$t(_vm.titleKey)))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }